import { useEffect, useState } from 'react';

import { ISelectedOption } from '../../@types/searchBox';
import { useDebounce } from './useDebounce';
import { getHotels } from '../../../components/StartCV/apiCaller';
import { filterHotelOptions } from '../../../components/StartCV/utils';

export interface IHotelSelectOption extends ISelectedOption {
  locationId?: string;
}

export function useSearchHotel (initialState: IHotelSelectOption[] = []) {
  const [searchText, setSearchText] = useState<string>('');
  const debounceSearchText = useDebounce(searchText);
  const [searchBoxOptions, setSearchBoxOptions] =
    useState<IHotelSelectOption[]>(initialState);
  const [selectedOptions, setSelectedOptions] =
    useState<IHotelSelectOption[]>(initialState);

  const parseHotelResponse = (response) => {
    const hotelList: IHotelSelectOption[] = [];
    response.results.map((hotel) => {
      hotelList.push({
        id: hotel.id,
        text: hotel.displayName,
        locationId: hotel.locationId,
      });
    });
    return hotelList;
  };

  useEffect(() => {
    if (searchText.length > 0) {
      getHotels({ name: debounceSearchText }).then((response) => {
        const hotelList = parseHotelResponse(response);
        setSearchBoxOptions(filterHotelOptions(searchText, hotelList));
      });
    }
  }, [debounceSearchText]);

  return {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSearchBoxOptions,
    setSelectedOptions,
    setSearchText,
  };
}
